[
  {
    "dia": "14T",
    "mupi": 2,
    "hora": "15h45min",
    "numero": 16,
    "titulo": "Toxina Botulínica no Controlo da Dor Miofascial Refratária: Caso Clínico",
    "autor": "Carolina Ferreira"
  },
  {
    "dia": "14T",
    "mupi": 2,
    "hora": "15h52min",
    "numero": 17,
    "titulo": "Materiais e técnica para confeção de chave de reposicionamento na colagem de fragmentos coronários",
    "autor": "Francisco Carneiro"
  },
  {
    "dia": "14T",
    "mupi": 2,
    "hora": "15h59min",
    "numero": 18,
    "titulo": "Abnormal Tooth Wear Associated with Tongue Piercings",
    "autor": "Diana Ramos"
  }
]